<div class="bg">


    <div class="container">
        <img src="../../../assets/logo.svg" alt="Jutlandia Logo" id="mainlogo" />
        <form (ngSubmit)="passwordReset()" class="form-signin" [formGroup]="forgottenPasswordForm">
            <input type="text"
                   class="form-control"
                   autofocus
                   formControlName="username"
                   placeholder="Enter your username"
                   autocomplete="username"
                   name="username" />

            <div class="form-buttons">
                <button type="submit" class="btn btn-block btn-primary" [disabled]="!forgottenPasswordForm.valid">Reset password</button>
            </div>
            <div class="forgotten-password">
                <a routerLink="/">Go back</a>
            </div>
        </form>
    </div>
</div>

